import React from "react";


const Footer = () => {

    return (
        <div>©2025@smartsolar.co.jp</div>
    );
};

export default Footer;